<template>
    <div>
        <Navigation />
        <!-- <div v-if="addNewNotification" class="popUp-overlay"></div> -->
        <div class="row tableUsers tableNotifications">
            <loader v-if="loaderActive" message="Please wait" />
            <div v-if="addNewNotification" class="popUp-overlay"></div>
            <div v-show="addNewNotification" class="popUp-dialogScrollable zHelper">
                <div class="col-md-12">
                    <form>
                        <div class="messages"></div>
                        <div class="controls">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group has-error has-danger">
                                        <label class="floatLeft" for="title">Notification Title</label>
                                        <input id="title" v-model="notification_title" type="text" name="title" 
                                            class="form-control" placeholder required="required" data-error="error"
                                            v-on:blur="checkUsers()" />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group has-error has-danger">
                                        <label class="floatLeft" for="notification_text">Notification text</label>
                                        <textarea id="text" v-model="notification_text" type="notification_text" name="text" 
                                            v-on:blur="checkUsers()" class="form-control" placeholder required="required"
                                            data-error="error" />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group has-error has-danger">
                                        <label class="floatLeft" for="scheduled_time">Scheduled date</label>
                                        <input id="title" v-model="scheduled_time" type="datetime-local" :min="currentDate"
                                            name="scheduled_time" @change="checkDates()" class="form-control"
                                            data-error="error" />
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group has-error has-danger">
                                        <label class="floatLeft" for="expiring_datetime">Expires on</label>
                                        <input id="title" v-model="expiring_datetime" type="datetime-local"
                                            name="expiring_datetime" @change="checkDates()" class="form-control" :min="currentDateEx" 
                                            data-error="error" />
                                    </div>
                                </div>
                            </div>


                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group has-error has-danger">
                                        <label class="floatLeft" for="selected_gender">Gender</label>
                                        <select v-model="selected_gender" name="selected_gender" @change="checkUsers()"
                                            :disabled="disabledFilters"
                                            class="custom-select custom-select-sm form-control form-control-sm">
                                            <option v-for="(item, index) in genders" v-bind:value="item.id">
                                                {{ item.text }}
                                            </option>
                                        </select>
                                        <!-- <input id="form_name" type="text" name="name" class="form-control" placeholder="" required="required" data-error="error"> -->
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group has-error has-danger">
                                        <label class="floatLeft" for="selected_municipality">Municipality</label>
                                        <select v-model="selected_municipality" name="selected_municipality"
                                            :disabled="disabledFilters" @change="checkUsers()"
                                            class="custom-select custom-select-sm form-control form-control-sm">
                                            <option v-for="(item, index) in municipalities" v-bind:value="item.id">
                                                {{ item.name_mk }}
                                            </option>
                                        </select>
                                        <!-- <input id="form_name" type="text" name="name" class="form-control" placeholder="" required="required" data-error="error"> -->
                                    </div>
                                </div>


                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group has-error has-danger">
                                        <label class="floatLeft" for="agefrom">Age from</label>
                                        <input id="title" v-model="agefrom" type="number" name="agefrom" 
                                            :disabled="disabledFilters" @change="checkUsers()" class="form-control"
                                            placeholder data-error="error" />
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group has-error has-danger">
                                        <label class="floatLeft" for="ageto">Age to</label>
                                        <input id="title" v-model="ageto" type="number" name="ageto"
                                            :disabled="disabledFilters" @change="checkUsers()" class="form-control"
                                            placeholder data-error="error" />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group has-error has-danger">
                                        <label class="floatLeft" for="users_emails">Users' emails</label>
                                        <textarea id="text" v-model="users_emails" type="users_emails" name="text"
                                            @blur="checkUsers()" class="form-control" placeholder data-error="error" />
                                    </div>
                                </div>
                            </div>

                            <div v-if="errorMsg" class="row">
                                <div class="col-md-12">
                                    <div class="error-infobox">{{ errorMsg }}</div>
                                </div>
                            </div>
                            <div class="row" v-if="usersCount || errorEmail">
                                <div class="col-md-12">
                                    <span v-if="usersCount" class="info-infobox label-infobox">
                                        {{ notifyMsg }}
                                    </span>
                                    <span v-if="errorEmail" class="error-infobox label-infobox"> {{ errorText }}</span>
                                </div>
                            </div>
                            <div class="row floatLeft submit-buttons">
                                <div class="col-md-12">
                                    <input @click.prevent="addNotification()" type="submit" :disabled="disabledSubmit"
                                        class="btn btnDark btn-success btn-send pointer" value="Submit" />
                                    <input
                                        v-on:click="addNewNotification = false;
                                        errorMsg = ''; clearForm();
                                                                                                                                                                                                                                                                                                                                                                                                                                  "
                                        type="cancel" class="btn btn-secondary pointer button-width-helper"
                                        value="Cancel" />

                                </div>
                            </div>

                        </div>
                    </form>
                </div>
            </div>

            <div v-show=" editN " class="popUp zHelper">
                <div class="col-md-12">
                    <form>
                        <div class="messages"></div>
                        <div class="controls">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group has-error has-danger">
                                        <label class="floatLeft" for="title">Notification Title</label>
                                        <input id="title" v-model=" notification_title " type="text" name="title"
                                            class="form-control" placeholder required="required" data-error="error"
                                            v-on:blur=" checkUsers() " />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group has-error has-danger">
                                        <label class="floatLeft" for="notification_text">Notification text</label>
                                        <textarea id="text" v-model=" notification_text " type="notification_text"
                                            name="text" v-on:blur=" checkUsers() " class="form-control" placeholder
                                            required="required" data-error="error" />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group has-error has-danger">
                                        <label class="floatLeft" for="scheduled_time">Scheduled date</label>
                                        <input id="title" v-model=" scheduled_time " type="datetime-local"
                                            name="scheduled_time" @change=" checkDates() " class="form-control" :min="currentDate"
                                            data-error="error" />
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group has-error has-danger">
                                        <label class="floatLeft" for="expiring_datetime">Expires on</label>
                                        <input id="title" v-model=" expiring_datetime " type="datetime-local"
                                            name="expiring_datetime" @change=" checkDates() " class="form-control" :min="currentDateEx"
                                            data-error="error" />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group has-error has-danger">
                                        <label class="floatLeft" for="selected_brand">Gender</label>
                                        <select v-model=" selected_gender " name="selected_gender" @change=" checkUsers() "
                                            :disabled=" disabledFilters "
                                            class="custom-select custom-select-sm form-control form-control-sm">
                                            <option v-for="(    item, index    ) in     genders    " v-bind:value=" item.id ">
                                                {{ item.text }}
                                            </option>
                                        </select>
                                        <!-- <input id="form_name" type="text" name="name" class="form-control" placeholder="" required="required" data-error="error"> -->
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group has-error has-danger">
                                        <label class="floatLeft" for="selected_municipality">Municipality</label>
                                        <select v-model=" selected_municipality " name="selected_municipality"
                                            :disabled=" disabledFilters " @change=" checkUsers() "
                                            class="custom-select custom-select-sm form-control form-control-sm">
                                            <option v-for="(    item, index    ) in     municipalities    "
                                                v-bind:value=" item.id ">
                                                {{ item.name_mk }}
                                            </option>
                                        </select>
                                        <!-- <input id="form_name" type="text" name="name" class="form-control" placeholder="" required="required" data-error="error"> -->
                                    </div>
                                </div>


                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group has-error has-danger">
                                        <label class="floatLeft" for="agefrom">Age from</label>
                                        <input id="title" v-model=" agefrom " type="number" name="agefrom"
                                            :disabled=" disabledFilters " @change=" checkUsers() " class="form-control"
                                            placeholder data-error="error" />
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group has-error has-danger">
                                        <label class="floatLeft" for="ageto">Age to</label>
                                        <input id="title" v-model=" ageto " type="number" name="ageto"
                                            :disabled=" disabledFilters " @change=" checkUsers() " class="form-control"
                                            placeholder data-error="error" />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group has-error has-danger">
                                        <label class="floatLeft" for="users_emails">Users' emails</label>
                                        <textarea id="text" v-model=" users_emails " type="users_emails" name="text"
                                            @blur=" checkUsers() " class="form-control" placeholder data-error="error" />
                                        <input type="hidden" v-model=" notification_id " value />
                                    </div>
                                </div>
                            </div>

                            <div v-if=" errorMsg " class="row">
                                <div class="col-md-12">
                                    <div class="error-infobox">{{ errorMsg }}</div>
                                </div>
                            </div>
                            <div class="row" v-if=" usersCount || errorEmail ">
                                <div class="col-md-12">
                                    <span v-if=" usersCount " class="info-infobox label-infobox">
                                        {{ notifyMsg }}
                                    </span>
                                    <span v-if=" errorEmail " class="error-infobox label-infobox"> {{ errorText }}</span>
                                </div>
                            </div>
                            <div class="row floatLeft submit-buttons">
                                <div class="col-md-12">
                                    <input @click.prevent=" editNotification() " type="submit" :disabled=" disabledSubmit "
                                        class="btn btnDark btn-success btn-send pointer" value="Save" />
                                    <input v-on:click="
                                        editN = false;
                                        errorMsg = ''; clearForm();
                                    " type="cancel" class="btn btn-secondary pointer button-width-helper"
                                        value="Cancel" />

                                </div>
                            </div>

                        </div>
                    </form>
                </div>

            </div>


            <div v-if=" deleteNotification " class="popUp-overlay"></div>
            <div v-show=" deleteNotification " class="popUp-dialog zHelper">
                <div class="col-md-12">
                    <form>
                        <div class="messages"></div>
                        <div class="controls">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group has-error has-danger">
                                        <label class="floatLeft" for="delete_brand_id">Are you sure you want to delete this
                                            notification?</label>
                                        <input type="hidden" v-model=" delete_notification_id "
                                            name="delete_notification_id" value />
                                        <label v-if=" errorMsg " class="floatLeft error-infobox">{{
                                            errorMsg
                                            }}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="row floatLeft submit-buttons">
                                <div class="col-md-12">
                                    <input @click.prevent=" confirmDelete() " type="submit"
                                        class="btn danger btnDark btn-success btn-send pointer" value="Yes" />
                                    <input v-on:click=" deleteNotification = false " type="cancel"
                                        class="btn btnDark btn-success pointer" value="No" />
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <div v-if=" notificationStatusAction " class="popUp-overlay"></div>
            <div v-show=" notificationStatusAction " class="popUp-dialog zHelper">
                <div class="col-md-12">
                    <form @submit.prevent>
                        <div class="messages"></div>
                        <div class="controls">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group has-error has-danger">
                                        <label class="floatLeft" for="form_name">You will archive the selected notification?
                                            Proceed?</label>
                                        <input type="hidden" v-model=" archive_id " name="archive_id" value />
                                        <label v-if=" errorMsg " class="floatLeft error-infobox">{{ errorMsg }}</label>
                                        <!-- <input id="form_name" type="text" name="name" class="form-control" placeholder="" required="required" data-error="error"> -->
                                    </div>
                                </div>
                            </div>
                            <div class="row floatLeft submit-buttons">
                                <div class="col-md-12">
                                    <input @submit.prevent v-on:click=" archiveNotification() " type="submit" class=" readonly
                              btn
                              danger
                              btnDark
                              btn-success btn-send
                              pointer
                            " value="Yes" />
                                    <input v-on:click=" notificationStatusAction = false " type="cancel"
                                        class="btn btnDark btn-success pointer" value="No" readonly />
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>


            <div class="col-md-12">
                <div class="card main-card">
                    <div class="card-body">
                        <div class="toolbar">
                            <!-- Here you can write extra buttons/actions for the toolbar -->
                        </div>
                        <div id="datatable_wrapper" class="dataTables_wrapper dt-bootstrap4" max-width="900px" responsive>
                            <div v-show=" hover " class="userStatBackground" style="width: auto !important;"
                                @mouseenter=" hover = true " @mouseleave=" hover = false ">
                                <div class="row justify-content-center">
                                    <v-card>

                                        <v-card-title>This notification has been sent to the following email
                                            accounts</v-card-title>


                                        <v-card-text>
                                            <ul class="notification_emails" style="list-style: none; text-align: left">
                                                <li role="row" v-bind:key=" index "
                                                    v-for="(        value, index        ) in         NotificationDetails        ">
                                                    {{
                                                    value }}</li>
                                            </ul>
                                        </v-card-text>
                                    </v-card>

                                </div>
                            </div>
                            <div v-show=" hoverText " class="userStatBackground notificationHover" style="width: auto !important;"
                                @mouseenter=" hoverText = true " @mouseleave=" hoverText = false ">
                                <div class="row justify-content-center">
                                    <v-card>
                                        <v-card-title v-if="notificationFullLabel">{{  notificationFullLabel }}</v-card-title>
                                        <v-card-text  v-if="notificationFullText">
                                            {{ notificationFullText }}
                                        </v-card-text>
                                    </v-card>

                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 col-md-4 tableName tableHeading">
                                    <a href="#" class="btn btn-round btn-icon btn-sm createNew mt-1"
                                        title="Add new notification" v-on:click=" addNew() ">
                                        <i class="fas fa-plus"></i>
                                    </a>
                                    Notifications
                                </div>
                                <div class="col-sm-12 col-md-5"></div>
                                <div class="col-sm-12 col-md-3">
                                    <div id="datatable_filter" class="dataTables_filter mt-3">
                                        <form
                                            class="form-inline md-form floatRight searchDiv form-sm active-darkGreen-2 mt-2">
                                            <input class="form-control borderNone form-control-sm mr-3" v-model=" search "
                                                v-on:keyup=" filterResults() " type="text" placeholder="Search"
                                                aria-label="Search" />
                                            <i class="fas fa-search" aria-hidden="true"></i>
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 col-md-2 mt-1 text-left pl-6 heading">
                                    Show notifications by status:
                                </div>
                                <div class="col-sm-2">
                                    <select class="form-control form-control-sm" id="selectedStatus"
                                        @change=" filterByStatus " v-model=" selectedStatus " required>
                                        <option v-bind:key=" index " v-for="(   option, index   ) in    statuses   "
                                            v-bind:value=" option.id ">
                                            {{ option.text }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 min-table-height">
                                    <table id="datatable" class="table table-striped table-bordered dataTable dtr-inline"
                                        cellspacing="0" responsive max-width="900px" width="100%" role="grid"
                                        aria-describedby="datatable_info" style="width: 100%">
                                        <thead>
                                            <tr role="row">
                                                <th class="sorting_asc" tabindex="0" aria-controls="datatable" rowspan="1"
                                                    colspan="1" style="width: 229px" aria-sort="ascending"
                                                    aria-label="Name: activate to sort column descending"
                                                    v-on:click=" sortResults(1) ">
                                                    Title
                                                </th>
                                                <th class="sorting_asc" tabindex="0" aria-controls="datatable" rowspan="1"
                                                    colspan="1" style="width: 229px" aria-sort="ascending"
                                                    aria-label="Name: activate to sort column descending"
                                                    v-on:click=" sortResults(2) ">
                                                    Text
                                                </th>
                                                <th class="sorting_asc" tabindex="0" aria-controls="datatable" rowspan="1"
                                                    colspan="1" style="width: 229px" aria-sort="ascending"
                                                    aria-label="Name: activate to sort column descending"
                                                    v-on:click=" sortResults(3) ">
                                                    Gender
                                                </th>
                                                <th class="sorting" tabindex="0" aria-controls="datatable" rowspan="1"
                                                    colspan="1" style="width: 229px"
                                                    aria-label="Age: activate to sort column ascending"
                                                    v-on:click=" sortResults(4) ">
                                                    Municipality
                                                </th>
                                                <th class="sorting_asc" tabindex="0" aria-controls="datatable" rowspan="1"
                                                    colspan="1" style="width: 229px" aria-sort="ascending"
                                                    aria-label="Name: activate to sort column descending"
                                                    v-on:click=" sortResults(5) ">
                                                    Age from
                                                </th>
                                                <th class="sorting_asc" tabindex="0" aria-controls="datatable" rowspan="1"
                                                    colspan="1" style="width: 229px" aria-sort="ascending"
                                                    aria-label="Name: activate to sort column descending"
                                                    v-on:click=" sortResults(6) ">
                                                    Age to
                                                </th>
                                                <th class="sorting_asc" tabindex="0" aria-controls="datatable" rowspan="1"
                                                    colspan="1" style="width: 229px" aria-sort="ascending"
                                                    aria-label="Name: activate to sort column descending"
                                                    v-on:click=" sortResults(3) ">
                                                    Emails
                                                </th>
                                                <th class="sorting" tabindex="0" aria-controls="datatable" rowspan="1"
                                                    colspan="1" style="width: 229px"
                                                    aria-label="Age: activate to sort column ascending"
                                                    v-on:click=" sortResults(7) ">
                                                    Scheduled on
                                                </th>
                                                <th class="sorting" tabindex="0" aria-controls="datatable" rowspan="1"
                                                    colspan="1" style="width: 229px"
                                                    aria-label="Age: activate to sort column ascending"
                                                    v-on:click=" sortResults(8) ">
                                                    Expires on
                                                </th>
                                                <th class="sorting" tabindex="0" aria-controls="datatable" rowspan="1"
                                                    colspan="1" style="width: 200px"
                                                    aria-label="Age: activate to sort column ascending"
                                                    v-on:click=" sortResults(9) ">
                                                    Created on
                                                </th>
                                                <th class="sorting" tabindex="0" aria-controls="datatable" rowspan="1"
                                                    colspan="1" style="width: 100px"
                                                    aria-label="Age: activate to sort column ascending">
                                                    Total users /seen
                                                </th>

                                                <th class="disabled-sorting text-right sorting" tabindex="0"
                                                    aria-controls="datatable" rowspan="1" colspan="1" style="width: 230px"
                                                    aria-label="Actions: activate to sort column ascending">
                                                    Actions
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr role="row" v-for="(        item, index        ) in         items        "
                                                v-bind:class="
                                                    [
                                                        index % 2 == 0 || index == 0 ? 'even' : 'odd',
                                                    ]
                                                ">
                                                <td width="15%" tabindex="0" class="sorting_1" style="word-break: break-all;" @mouseenter="showFullText(item.title, type = 1)" @mouseleave="hoverText=false" @mouseup="notificationText=true; hoverText=false">{{ item.title | truncate(30, '...') }}</td>
                                                <td width="15%" style="word-break: break-all;" @mouseenter=" showFullText(item.text, type = 2) "
                                                    @mouseleave=" hoverText = false;" @mouseup="
                                                        notificationText = true;
                                                        hoverText = false; 
                                                    ">{{ item.text | truncate(60, '...') }}</td>

                                                <td>{{ getGender(item.gender) }}</td>
                                                <td>{{ item.municipality_name }}</td>
                                                <td>{{ item.agefrom }}</td>
                                                <td>{{ item.ageto }}</td>
                                                <td>
                                                    <i v-if=" item.emails " class="far fa-eye" id="latestUserActivity"
                                                        @mouseenter=" showEmails(item.emails) "
                                                        @mouseleave=" hover = false " @mouseup="
                                                            userEmails = true;
                                                            hover = false;
                                                        "></i>
                                                </td>
                                                <td>{{ item.scheduled_time }}</td>
                                                <td>{{ item.expiring_datetime }}</td>
                                                <td>{{ item.createdon }}</td>
                                                <td>{{ getTotal(item.total_notifications, item.nonseen_notifications) }}
                                                </td>
                                                <td class="text-right" style="width: 15%;">
                                                    <div class="actions_on_user">
                                                        <a href="#" class="btn btn-round btn-edit btn-icon btn-sm edit"
                                                            v-if=" item.is_archived == 0 "
                                                            :class=" { isDisabled: new Date(item.scheduled_time).getTime() < new Date().getTime() } "
                                                            @click.prevent=" edit(item.id) " id="edit">
                                                            <i class="far fa-edit"></i>
                                                        </a>
                                                        <label class="activity_label" for="edit">Edit</label>
                                                    </div>
                                                    <div class="actions_on_user">
                                                        <a href="#" class="btn btn-round btn-danger btn-icon btn-sm remove"
                                                            v-on:click=" del(item.id) " id="delete">
                                                            <i class="fas fa-times"></i>
                                                        </a>
                                                        <label class="activity_label" for="delete">Delete</label>
                                                    </div>


                                                    <div class="actions_on_user" v-if=" item.is_archived == 0 ">
                                                        <a href="#"
                                                            class=" btn btn-round btn-success btn-icon btn-sm remove "
                                                            v-on:click="
                                                                archive_id = item.id;
                                                                notificationStatusAction = true;
                                                            " id="archiveNotification">
                                                            <i class="fas fa-archive"></i>
                                                        </a>
                                                        <label class="activity_label"
                                                            for="archiveNotification">Archive</label>
                                                    </div>

                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <pagination :meta_data=" meta_data " v-on:next=" fetchResults "></pagination>
                        </div>
                    </div>
                    <!-- end content-->
                </div>
                <!--  end card  -->
            </div>
            <!-- end col-md-12 -->
        </div>
    </div>
</template>
  
<script>
import axios from 'axios';
import Navigation from "@/views/Navigation.vue";
import Pagination from "@/components/Pagination.vue";
import UserNotification from "@/components/UserNotification.vue"
import Loader from '@/components/Loader.vue'
import store from "./../store/index";
export default {
    components: {
        Navigation,
        Pagination,
        Loader,
        UserNotification
    },
    data() {
        return {
            addNewNotification: false,
            hover: false,
            hoverText: false,
            editN: false,
            // deleteNotification: false,
            errors: [],
            items: [],
            statuses: [{
                id: 0,
                text: 'Active'
            }, {
                id: 1,
                text: 'Archived'
            }],
            genders: [{
                id: 1,
                text: 'Male'
            }, {
                id: 2,
                text: 'Female'
            }],
            municipalities: [],
            search: null,
            order: null,
            dir: 0,
            sort: null,
            package_name: null,
            selected_municipality: null,
            notification_title: null,
            users_emails: null,
            selected_gender: null,
            notification_id: "",
            notificationStatusAction: false,
            notification_text: null,
            deleteNotification: false,
            delete_notification_id: "",
            archive_id: null,
            errorMsg: "",
            errorText: "",
            usersCount: null,
            notifyMsg: "",
            errorEmail: null,
            edit_package_name: "",
            edit_package_brand_id: null,
            agefrom: null,
            ageto: null,
            expiretime: null,
            expiring_datetime: null,
            scheduled_time: null,
            NotificationDetails: [],
            disabledSubmit: false,
            disabledFilters: false,
            selectedStatus: 0,
            scheduled_picker: null,
            datetime: null,
            notificationFullText: null,
            notificationFullLabel: null,
            loaderActive: false,
            currentDate: new Date().toISOString().slice(0,16).toString(),
            currentDateEx: new Date().toISOString().slice(0,16).toString(),
            meta_data: {
                last_page: null,
                current_page: 1,
                prev_page_url: null,
                perpage: 5,
                total: 0,
            },
        };
    },
    mounted() {
        this.fetchResults(
            this.meta_data.page,
            this.meta_data.perpage,
            this.search,
            this.order,
            this.sort
        );
    },

    methods: {
        validateForm() {
            if (!this.notification_text && !this.notification_title) {
                this.errorMsg = 'Title and text are required';
                return false;
            } else if (this.notification_text && !this.notification_title) {
                this.errorMsg = 'Title is  required'; return false;
            } else if (!this.notification_text && this.notification_title) {
                this.errorMsg = 'Text is required'; return false;

            } else {
                this.errorMsg = ''; return true
            }
        },
        addNew() {
            this.$data.addNewNotification = true;
            this.fetchMunicipalities();
        },
        edit(id) {
            this.$data.editN = true;

            axios
                .get(store.state.BASE_URI + "admin/notifications/fetch_notification", {
                    headers: { Authorization: localStorage.getItem("accessToken") },
                    params: {
                        id,
                    },
                })
                .then((res) => {
                    this.notification_id = res.data.content.id;
                    this.notification_title = res.data.content.title;
                    this.notification_text = res.data.content.text;
                    this.users_emails = res.data.content.emails;
                    this.selected_gender = res.data.content.gender;
                    this.selected_municipality = res.data.content.municipality_id;
                    this.agefrom = res.data.content.agefrom;
                    this.ageto = res.data.content.ageto;
                    if (res.data.content.scheduled_time) {

                        this.scheduled_time = res.data.content.scheduled_time
                    }
                    if (res.data.content.expiring_datetime) {

                        this.expiring_datetime = res.data.content.expiring_datetime
                    }

                    this.checkUsers();
                    this.checkDates();
                    this.fetchMunicipalities();

                });
        },
        del(id) {
            this.delete_notification_id = this.errorMsg = "";
            this.delete_notification_id = id;
            this.$data.deleteNotification = true;
        },
        confirmDelete() {
            axios
                .delete(
                    store.state.BASE_URI +
                    "admin/notifications/item/" +
                    this.delete_notification_id,
                    { headers: { Authorization: localStorage.getItem("accessToken") } }
                )
                .then((res) => {
                    this.fetchResults(
                        this.meta_data.page,
                        this.meta_data.perpage,
                        this.search,
                        this.order,
                        this.sort
                    );
                    this.deleteNotification = false;
                    this.$toasted
                        .show(res.data.message, {
                            type: "success",
                        })
                        .goAway(2000);
                })
                .catch((error) => {
                    if (error) {
                        console.log(error)
                        this.errorMsg = error.response.data.message;
                        this.$toasted
                            .show(this.errorMsg, {
                                type: "error",
                            })
                            .goAway(2000);
                    }
                });
        },
        fetchResults(
            page = this.meta_data.current_page,
            perpage = this.meta_data.perpage,
            search = this.search,
            order = this.order,
            sort = this.sort,
            total = this.meta_data.total,
            archived = this.selectedStatus
        ) {

            this.showLoader(),
            axios
                .get(store.state.BASE_URI + "admin/notifications/load_notifications", {
                    headers: { Authorization: localStorage.getItem("accessToken") },
                    params: {
                        page,
                        perpage,
                        search,
                        order,
                        sort,
                        total,
                        archived
                    },
                })
                .then((res) => {
                    this.hideLoader();
                    console.log(res.data.content);
                    this.items = res.data.content.results;
                    var pagination = res.data.content.pagination;
                    this.meta_data.last_page = pagination.last_page;
                    this.meta_data.current_page = pagination.current_page;
                    this.meta_data.prev_page_url = pagination.prev_page_url;
                    this.meta_data.perpage = pagination.perpage;
                    this.meta_data.search = pagination.search;
                    this.meta_data.total = pagination.total;
                }).finally(() => this.hideLoader());
        },
        filterResults() {
            this.meta_data.current_page = 1;
            this.fetchResults(
                this.meta_data.page,
                this.meta_data.perpage,
                this.search,
                this.order,
                this.sort,
                this.selectedStatus
            );
        },
        sortResults(order) {
            this.dir++;
            this.order = order;

            if (this.dir % 2 == 0) this.sort = "desc";
            else this.sort = "asc";
            this.fetchResults(
                this.meta_data.page,
                this.meta_data.perpage,
                this.search,
                this.order,
                this.sort
            );
        },
        getGender(id) {

            var selectedgen = '';
            this.genders.forEach((value, index) => {
                if (value.id == id) {
                    selectedgen = value.text
                }

            })

            return selectedgen
        },
        getTotal(total, notseen) {

            // var seen_notifications = total - notseen;
            var calculated = total + ' / ' + notseen;


            return calculated
        },
        fetchMunicipalities() {
            axios
                .get(store.state.BASE_URI + "admin/notifications/fetch_municipalities", {
                    headers: { Authorization: localStorage.getItem("accessToken") },
                })
                .then((res) => {
                    this.municipalities = res.data.results.municipalities;
                    console.log(this.municipalities)
                });
        },
        addNotification() {

            var validated = this.validateForm();
            if (validated) {
                var post_data = {

                    title: this.notification_title,
                    text: this.notification_text,
                    gender: this.selected_gender,
                    municipality_id: this.selected_municipality,
                    agefrom: this.agefrom,
                    ageto: this.ageto,
                    scheduled_time: this.scheduled_time,
                    expiring_datetime: this.expiring_datetime,
                    users_emails: this.users_emails,

                }
                axios.defaults.headers.common["Authorization"] = localStorage.getItem(
                    "accessToken"
                );
                this.showLoader(),
                axios
                    .post(store.state.BASE_URI + "admin/notifications/create", {
                        params: post_data,
                        headers: {
                            "Content-Type": "text/plain;charset=utf-8",
                        },
                    })
                    .then((response) => {
                        this.addNewNotification = false;
                        this.fetchResults(
                            this.meta_data.page,
                            this.meta_data.perpage,
                            this.search,
                            this.order,
                            this.sort
                        );
                        this.errorMsg = "";
                        this.$toasted
                            .show(response.data.message, {
                                type: "success",
                            })
                            .goAway(2000);
                        this.clearForm();
                        this.hideLoader()
                    })
                    .catch((error) => {
                        if (error) {
                            this.errorMsg = error.response.data.message;
                            this.hideLoader();
                            this.$toasted
                                .show(this.errorMsg, {
                                    type: "error",
                                })
                                .goAway(2000);

                        }
                    }).finally(() => this.hideLoader());;
            }

        },
        editNotification() {
            this.validateForm();
            var post_data = {
                id: this.notification_id,
                title: this.notification_title,
                text: this.notification_text,
                gender: this.selected_gender,
                municipality_id: this.selected_municipality,
                agefrom: this.agefrom,
                ageto: this.ageto,
                scheduled_time: this.scheduled_time,
                expiring_datetime: this.expiring_datetime,
                users_emails: this.users_emails,
            }

            axios.defaults.headers.common["Authorization"] = localStorage.getItem(
                "accessToken"
            );
            axios
                .post(store.state.BASE_URI + "admin/notifications/edit", {
                    params: {
                        id: this.notification_id,
                        title: this.notification_title,
                        text: this.notification_text,
                        gender: this.selected_gender,
                        municipality_id: this.selected_municipality,
                        agefrom: this.agefrom,
                        ageto: this.ageto,
                        scheduled_time: this.scheduled_time,
                        expiring_datetime: this.expiring_datetime,
                        users_emails: this.users_emails,
                    },
                    headers: {
                        "Content-Type": "text/plain;charset=utf-8",
                    },
                })
                .then((response) => {
                    this.editN = false;
                    this.clearForm();
                    this.fetchResults(
                        this.meta_data.page,
                        this.meta_data.perpage,
                        this.search,
                        this.order,
                        this.sort
                    );
                    this.$toasted
                        .show(response.data.message, {
                            type: "success",
                        })
                        .goAway(2000);
                })
                .catch((error) => {
                   
                    if (error) {
                        this.errorMsg = error.response.data.message;
                        console.log(error.response.data.message);
                        this.$toasted
                            .show(this.errorMsg, {
                                type: "error",
                            })
                            .goAway(2000);
                    }
                });
        },

        showEmails(emails = null) {
            if (emails) {
                this.hover = true;
                this.NotificationDetails = emails.split(";")
            } else {
                this.NotificationDetails = null;
            }

        },
        showFullText(text, type) {
            if(type == 1) {
                var maxChars = 30;
                 this.notificationFullLabel = 'Notification full title: ';
            }
            else if(type == 2){
                var maxChars = 60;
                this.notificationFullLabel = 'Notification full text: ';
            } 
            if (text.length >= maxChars) {
                this.hoverText = true;
                this.notificationFullText = text;
            } else {
                this.hoverText = false;
                this.notificationFullText = null;
                this.notificationFullLabel = null;
            }
        },

        clearForm() {
            this.selected_gender = null;
            this.notification_title = '';
            this.notification_text = '';
            this.users_emails = '';
            this.disabledSubmit = false;
            this.disabledFilters = false;
            this.selected_municipality = null;
            this.agefrom = '';
            this.ageto = '';
            this.scheduled_time = null;
            this.expiring_datetime = null;
            this.notifyMsg = '';
            this.errorText = '';
            this.currentDate = new Date().toISOString().slice(0,16).toString();
            this.currentDateEx = new Date().toISOString().slice(0,16).toString();

        },

        checkUsers() {

            if (this.users_emails != null && this.users_emails != '') {
                this.disabledSubmit = false;
                this.disabledFilters = true;
                //clear and disable other Filters

                this.selected_gender = "";
                this.selected_municipality = "";
                this.agefrom = "";
                this.ageto = "";

                this.errorText = null;
                var emails = this.users_emails;
                console.log(emails);
                emails = emails.split(";");
                emails = emails.filter((str) => str !== '');
                console.log(emails);
                var validEmails = false;
                var countValidEmails = 0;
                emails.forEach((element, index) => {
                    element = element.trim();
                    console.log(element);
                    if (element != '') {
                        if (
                            element.match(
                                /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                            )) {
                            countValidEmails++;
                        }
                    }

                });

                if (emails.length == countValidEmails) {
                    var params = {
                        users_emails: this.users_emails,
                    }
                    axios
                        .get(store.state.BASE_URI + "admin/notifications/fetch_users_by_filters", {
                            headers: { Authorization: localStorage.getItem("accessToken") },
                            params: params,
                        })
                        .then((res) => {
                            this.usersCount = parseInt(res.data.results[0].total);
                            if (this.usersCount > 0)
                                this.notifyMsg = "Notification will be sent to " + this.usersCount + " users";
                            else {
                                this.notifyMsg = "0 users have been found with the selected filter. Notification can not be created with 0 related users";
                                this.disabledSubmit = true;
                            }
                        });
                } else {
                    this.notifyMsg = "";
                    this.errorEmail = emails.length - countValidEmails;
                    this.errorText = "There are " + this.errorEmail + " invalid email adresses in the email filter box ";
                    this.disabledSubmit = true;
                }

            } else {
                this.errorText = null;
                this.disabledSubmit = false;
                this.disabledFilters = false;
                console.log(this.agefrom);
                console.log(this.ageto);
                var params = {

                    gender: this.selected_gender,
                    municipality_id: this.selected_municipality,
                    agefrom: this.agefrom,
                    ageto: this.ageto,
                }
                console.log(params)
                axios
                    .get(store.state.BASE_URI + "admin/notifications/fetch_users_by_filters", {
                        headers: { Authorization: localStorage.getItem("accessToken") },
                        params: params,
                    })
                    .then((res) => {
                        this.usersCount = parseInt(res.data.results[0].total);
                        if (this.usersCount > 0)
                            this.notifyMsg = "Notification will be sent to " + this.usersCount + " users";
                        else {
                            this.errorText = "0 users have been found with the selected filter. Notification can not be created with 0 related users";
                            this.disabledSubmit = true;
                            this.errorEmail = true;

                        }
                    });
            }

        },
        checkDates() {
            this.errorEmail = false;
            this.errorText = "";
            this.disabledSubmit = false;
         
            if(this.scheduled_time != null && this.scheduled_time != ''){
                this.currentDateEx = this.scheduled_time;
            }

            if (this.expiring_datetime != null && this.expiring_datetime != '' && (this.expiring_datetime < this.scheduled_time)) {
                this.errorEmail = true;
                this.disabledSubmit = true;
                this.errorText = "The date of expiration of the notification can not be before the scheduled date"
            }
        },
        archiveNotification() {

            axios.defaults.headers.common["Authorization"] = localStorage.getItem(
                "accessToken"
            );
            axios
                .post(store.state.BASE_URI + "admin/notifications/mark_as_archived", {
                    params: {
                        id: this.archive_id,

                    },
                    headers: {
                        "Content-Type": "text/plain;charset=utf-8",
                    },
                })
                .then((response) => {
                    this.notificationStatusAction = false;
                    this.fetchResults(
                        this.meta_data.page,
                        this.meta_data.perpage,
                        this.search,
                        this.order,
                        this.sort
                    );
                    this.$toasted
                        .show(response.data.message, {
                            type: "success",
                        })
                        .goAway(2000);
                })
                .catch((error) => {
                    if (error) {
                        this.errorMsg = error.response.data.message;
                        console.log(error.response.data.message);

                        this.$toasted
                            .show(this.errorMsg, {
                                type: "error",
                            })
                            .goAway(2000);

                    }
                });

        },
        filterByStatus() {
            this.meta_data.current_page = 1;
            this.meta_data.perpage = 5,
                this.fetchResults();
        },
        showLoader() {
            this.loaderActive = true;
            this.disabledSubmit = true;
        },
        hideLoader() {
            this.loaderActive = false;
            this.disabledSubmit = false;
        },
    },
    filters: {
        truncate: function (text, length, suffix) {
            if (text.length > length) {
                return text.substring(0, length) + suffix;
            } else {
                return text;
            }
        },

    }
};
</script>

<style src="../css/style.css"></style>
<style>
.notificationtime .v-time-picker-title {
    color: black !important;
    justify-content: flex-start !important;
}

.notificationtime .v-time-picker-title__time .v-picker__title__btn,
.notificationtime .v-time-picker-title__time span {
    font-size: 24px !important
}
</style>
  